import { combineReducers } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import { persistReducer } from 'redux-persist';
import { app, AppState } from 'reducers/app';
import { auth, AuthState } from 'reducers/auth';
import orders, { OrderState } from 'pages/Orders/Manage/slice';
import customers, { CustomerState } from 'pages/Customers/slice';
import partners, { PartnerState } from 'pages/Partners/slice';
import warehouse, { WarehouseState } from './warehouse/warehouse.reducer';

const authPersistConfig = {
  key: 'auth',
  storage: storage,
  stateReconciler: autoMergeLevel2,
  whitelist: [
    'accessToken',
    'profile',
    'postalList',
    'pageList',
    'userWarehouse',
    'loginState',
    'warehouseList',
  ],
};

const appPersistConfig = {
  key: 'app',
  storage: storage,
  stateReconciler: autoMergeLevel2,
  whitelist: [
    'navLockStatus',
    'userConfig',
    'appConfig',
    'recentList',
    'favoriteList',
    'theme',
    'language',
  ],
};

const persistedAuthReducer = persistReducer<AuthState>(authPersistConfig, auth);
const persistedAppReducer = persistReducer<AppState>(appPersistConfig, app);

export interface IStore {
  auth: AuthState;
  orders: OrderState;
  app: AppState;
  customers: CustomerState;
  warehouse: WarehouseState;
  partners: PartnerState;
}

const root = combineReducers<IStore>({
  app: persistedAppReducer,
  auth: persistedAuthReducer,
  orders,
  customers,
  warehouse,
  partners,
});

export type RootState = ReturnType<typeof root>;

export default root;
